import { useMemo } from "react";
import { FormattedMessage } from "react-intl";

import styles from "@components/TagList.module.css";
import Tooltip from "@components/Tooltip";

type Props = {
  tags: string[];
};

const TagList = ({ tags }: Props) => {
  const fullTagList = useMemo(
    () => (
      <>
        {tags.map(tag => (
          <div className={styles.tag} key={tag}>
            {tag}
          </div>
        ))}
      </>
    ),
    [tags]
  );

  return (
    <>
      {tags.slice(0, 2).map(tag => (
        <div className={styles.tag} key={tag}>
          {tag}
        </div>
      ))}
      {tags.length > 2 && (
        <Tooltip content={fullTagList}>
          {tooltipTriggerProps => (
            <div className={`${styles.tag} ${styles.overflow}`} tabIndex={0} {...tooltipTriggerProps}>
              <FormattedMessage id="models.tagList.overflow" values={{ count: tags.length - 2 }} />
            </div>
          )}
        </Tooltip>
      )}
    </>
  );
};

export default TagList;
